const printParam = param => {
  if (typeof param === 'string') {
    return `'${param}'`;
  } else if (typeof param === 'object') {
    return JSON.stringify(param);
  } else if (param === undefined) {
    return 'undefined';
  }
  return param;
};
const printParams = args => args.map(arg => printParam(arg)).join(',');
export const printFunctionCall = (fn, ...args) => `(${fn.toString()})(${printParams(args)});`;
export const printScript = statements => `(function(){
  ${statements.join(';')}
})();
`;